import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { onFieldsChange, getLogs } from './action';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';

class OperalogsList extends React.Component {
    constructor(props) {
        super(props);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getLogs(); //查询操作日志
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(Object.assign(_obj, { page: 1, pageSize: 10 }));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            _obj[key] = fields[key].value;
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    handlePaginationChange(page, per_page) {
        this.props.onFieldsChange({ page: page, pageSize: per_page });
        this.props.getLogs();
    }

    render() {
        let columns = [
            
            {
                title: '订单名称',
                dataIndex: 'taskDescription',
                key: 'taskDescription',
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '任务ID',
                dataIndex: 'taskid',
                key: 'taskid',
            },
            {
                title: '广告ID',
                dataIndex: 'adid',
                key: 'adid',
            },
            {
                title: 'PS',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '日期',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '开屏',
                dataIndex: 'splash',
                key: 'splash',
            },
            {
                title: '轮播图',
                dataIndex: 'banner',
                key: 'banner',
            },
            {
                title: '信息流',
                dataIndex: 'flow',
                key: 'flow',
            },
            {
                title: '广点通开屏',
                dataIndex: 'splashGdt',
                key: 'splashGdt',
            },
            {
                title: '穿山甲开屏',
                dataIndex: 'splashCsj',
                key: 'splashCsj',
            },
            {
                title: '广点通banner',
                dataIndex: 'bannerGdt',
                key: 'bannerGdt',
            },
            {
                title: '穿山甲banner',
                dataIndex: 'bannerCsj',
                key: 'bannerCsj',
            },
            {
                title: '广点通信息流',
                dataIndex: 'flowGdt',
                key: 'flowGdt',
            },
            {
                title: '穿山甲信息流',
                dataIndex: 'flowCsj',
                key: 'flowCsj',
            },
            {
                title: '广点通插屏',
                dataIndex: 'popGdt',
                key: 'popGdt',
            },
            {
                title: '穿山甲插屏',
                dataIndex: 'popCsj',
                key: 'popCsj',
            },
            {
                title: '广点通全屏',
                dataIndex: 'fullGdt',
                key: 'fullGdt',
            },
            {
                title: '穿山甲全屏',
                dataIndex: 'fullCsj',
                key: 'fullCsj',
            }
        ];
        const { logs, loading, search } = this.props;
        const { total } = search;
        return (
            <div>
                <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                <Spin spinning={loading} tip="加载中">
                    <Table columns={columns} dataSource={logs} pagination={false} bordered />
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        total={total}
                        className="ant-table-pagination"
                        onChange={this.handlePaginationChange}
                        onShowSizeChange={this.handlePaginationChange}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.operaMonitor.loading.loading,
    search: state.operaMonitor.search,
    logs: state.operaMonitor.logs,
});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getLogs: () => dispatch(getLogs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OperalogsList);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getLogs();
    }

    render() {
        const { areas, agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>广点通统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                <Row style={{ marginBottom: '10px' }}>
                        <Col span={6} >
                            <FormItem label="任务ID" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('taskid')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={6} >
                            <FormItem label="广告ID" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('adid')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="PS" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('ps')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '10px' }}>
                         <Col span={6}>
                           <FormItem label="开始时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('beginTm')(
                                    <DatePicker style={{ width: 220 }} showTime format="YYYY-MM-DD" />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="结束时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('endTm')(
                                    <DatePicker style={{ width: 220 }} showTime format="YYYY-MM-DD" />,
                                )}
                            </FormItem>
                        </Col> 
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/phoneDetail/index.js